import React, { useEffect } from 'react'

// GraphQL
import { useQuery } from '@apollo/client'
import query from './query.graphql'

// hooks
import { useAppSettings } from 'components/shared/SettingsProvider'

const withQuery = WrappedComponent => {
  return props => {
    const {
      resetCartForm, // from redux actions
      onQueryError, // from withQueryResults
      onLoggedInQueryCompleted // from withQueryResults
    } = props

    const { enableReservationsByDay } = useAppSettings()

    // react hooks
    const { loading, data, refetch } = useQuery(query, {
      onCompleted: data => {
        onLoggedInQueryCompleted(data)
      },
      onError: onQueryError
    })

    // Update Redux cart form whenever data changes (including from refetches)
    useEffect(() => {
      if (data && data.viewer && data.sessions) {
        const {
          viewer: { campers, cart },
          sessions
        } = data

        resetCartForm({
          cart,
          campers,
          sessions
        })
      }
    }, [data, resetCartForm])

    // GraphQL data
    const { viewer: account, sessions, seasons, appConfig } = data || {}
    const season = seasons ? seasons[0] : {}
    const filteredSessions = sessions
      ? sessions.filter(s => s.sessionType !== 'online')
      : null
    const session = filteredSessions ? filteredSessions[0] : null
    const { enableCovidRequirements } = appConfig || {}

    return (
      <WrappedComponent
        loading={loading}
        account={account}
        sessions={filteredSessions}
        session={session}
        season={season}
        enableCovidRequirements={enableCovidRequirements}
        enableReservationsByDay={enableReservationsByDay}
        refetchCart={refetch}
        {...props}
      />
    )
  }
}

export default withQuery
